<template>
  <div class="settings" :class="{ 'settings--mobile': isMobile }">
    <div class="d-flex">
      <ai-tabs v-model="settingsTab" :items="settingsTabs" />
    </div>

    <div class="settings__content">
      <v-window v-model="settingsTab" class="settings__content__list">
        <v-window-item
          transition="transition"
          class="w-100 settings__content__list__item"
          :value="settingsTabs[0].value"
        >
          <themes-settings />
        </v-window-item>
        <v-window-item
          transition="transition"
          class="w-100 settings__content__list__item"
          :value="settingsTabs[1].value"
        >
          <prompt-settings />
        </v-window-item>
      </v-window>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import i18n from '@/plugins/i18n';

import { useEditorStore } from '@/store/editor';
import { useCommonStore } from '@/store/common';

import { TTab } from '@/types/TTab';
import { TTabItem } from '@/types/TTabItem';

import AiTabs from '@/components/UI/AiTabs/AiTabs.vue';

import ThemesSettings from '@/components/pages/Generate/ThemesSettings/ThemesSettings.vue';
import PromptSettings from '@/components/pages/Generate/PromptSettings/PromptSettings.vue';

const { t } = useI18n();

const settingsTabs = ref<TTabItem[]>([
  { label: t('editor.settings.theme'), value: 'theme' },
  { label: t('editor.settings.prompt'), value: 'prompt' },
]);

const { generateImageData } = storeToRefs(useEditorStore());
const { isMobile } = storeToRefs(useCommonStore());

const settingsTab = ref<TTab>(generateImageData.value.activeTab);

const lang = computed(() => i18n.global.locale.value);

watch(settingsTab, (newVal) => {
  generateImageData.value.activeTab = newVal;
});

watch(
  () => generateImageData.value.activeTab,
  (newVal) => {
    settingsTab.value = newVal;
  },
);

watch(lang, () => {
  settingsTabs.value = [
    { label: t('editor.settings.theme'), value: 'theme' },
    { label: t('editor.settings.prompt'), value: 'prompt' },
  ];
});
</script>

<style scoped lang="scss" src="./ProductSettings.scss" />
